import React from 'react';
import Icon from '../../../components/AppIcon';

const LeaveTypeSelector = ({ selectedTypes, onTypeToggle }) => {
  const leaveTypes = [
    {
      id: 'annual',
      label: 'Annual Leave',
      icon: 'Calendar',
      color: 'bg-primary',
      textColor: 'text-primary-foreground',
      borderColor: 'border-primary'
    },
    {
      id: 'sick',
      label: 'Sick Leave',
      icon: 'Heart',
      color: 'bg-error',
      textColor: 'text-error-foreground',
      borderColor: 'border-error'
    },
    {
      id: 'maternity',
      label: 'Maternity Leave',
      icon: 'Baby',
      color: 'bg-accent',
      textColor: 'text-accent-foreground',
      borderColor: 'border-accent'
    },
    {
      id: 'longService',
      label: 'Long Service Leave',
      icon: 'Award',
      color: 'bg-success',
      textColor: 'text-success-foreground',
      borderColor: 'border-success'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
      {leaveTypes?.map((type) => {
        const isSelected = selectedTypes?.includes(type?.id);
        return (
          <button
            key={type?.id}
            onClick={() => onTypeToggle(type?.id)}
            className={`
              flex items-center gap-2 md:gap-3 px-3 md:px-4 py-3 md:py-4 rounded-md border-2 transition-smooth
              ${isSelected 
                ? `${type?.color} ${type?.textColor} ${type?.borderColor} shadow-md` 
                : 'bg-card text-foreground border-border hover:border-muted-foreground hover-lift'
              }
            `}
            aria-pressed={isSelected}
          >
            <Icon 
              name={type?.icon} 
              size={20} 
              color={isSelected ? 'currentColor' : 'var(--color-muted-foreground)'} 
            />
            <span className="font-body font-medium text-sm md:text-base">{type?.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default LeaveTypeSelector;